// eslint-disable-next-line
module.exports = require(process.env.NODE_ENV === 'test'
  ? './store.production'
  : `./store.${process.env.NODE_ENV}`);
